import { c as _c } from "react/compiler-runtime";
import { createQueryFn, drawQueryKeys } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getOpenedDraws } from '../../../actions/draw/entry.js';
const fetcher = createQueryFn(getOpenedDraws);
/**
 * Gets opened product draws from Tanstack Query context.
 *
 * @param product Product to get opened draws for
 * @param queryOptions Fetch query options
 * @returns Opened draws or undefined
 */
export function useOpenedDraws(product, queryOptions) {
  const $ = _c(8);
  let t0;
  if ($[0] !== product) {
    t0 = drawQueryKeys.openedDraws(product);
    $[0] = product;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[2] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== queryOptions || $[5] !== t0 || $[6] !== t2) {
    t3 = {
      ...queryOptions,
      queryKey: t0,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      queryFn: t2
    };
    $[4] = queryOptions;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useSuspenseQuery(t3);
}